import { Evidence } from '@/@types/Evidence';
import { EvidenceCard } from '@/components/table/EvidenceCard';
import {
  InlinePaperChipWidget,
  InlinePaperChipWidgetProps,
} from '@/components/widgets/InlinePaperChipWidget';

import { FC } from 'react';

interface InlinePaperChipWidgetWithEvidenceProps
  extends InlinePaperChipWidgetProps {
  evidences: Evidence[];
  onOpenOrClose?: (isOpen: boolean) => void;
}

export const InlinePaperChipWidgetWithEvidence: FC<
  InlinePaperChipWidgetWithEvidenceProps
> = (props) => {
  const { evidences, onOpenOrClose, ...rest } = props;

  if (evidences.length === 0) {
    return <InlinePaperChipWidget {...rest} />;
  }
  return (
    <>
      <InlinePaperChipWidget {...rest} />
      <EvidenceCard onOpenOrClose={onOpenOrClose} evidences={evidences} />
    </>
  );
};
